import React, { useState, useRef } from "react"
import "../styles/contact.css"
import { useInput } from "../hooks/useInput"
import emailjs, { init } from "@emailjs/browser"
import { Alert, AlertProps } from "react-bootstrap"
import Footer from "./Footer"

export default function ContactForm() {
  const [name, onChangeName, setName] = useInput()
  const [email, onChangeEmail, setEmail] = useInput()
  const [msg, onChangeMsg, setMsg] = useInput()
  const [success, setSuccess] = useState()
  const form = useRef()

  const sendMail = async (e) => {
    e.preventDefault()
    setSuccess("")
    try {
      await emailjs.sendForm(
        "service_vw3vz4s",
        "portfolio_form",
        form.current,
        "ydq6dM56Nt0IjhhGu"
      )
      setSuccess("Email was Successfully sent, I'll definitely send a reply.")
      setName("")
      setMsg("")
      setEmail("")
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <div className="contact" id="contact">
        <h2 className="text-capitalize text-center display-4 fw-bold">
          get in touch
        </h2>
        <p className="text-center mx-auto msg">
          I’m currently looking for new opportunities, my inbox is always open.
          Whether you have a question, a proposal or just want to say hi, I’ll
          get back to you!
        </p>
        {success && (
          <Alert variant="success" className="text-center w-75 m-auto">
            {success}
          </Alert>
        )}
        <form className="contact-form" onSubmit={sendMail} ref={form}>
          <p type="Name:">
            <input
              placeholder="Write your name here.."
              value={name}
              name="sender_name"
              onChange={onChangeName}
            ></input>
          </p>

          <p type="Email:">
            <input
              placeholder="Let me know how to contact you back.."
              name="sender_email"
              value={email}
              onChange={onChangeEmail}
            ></input>
          </p>

          <p type="Message:">
            <textarea
              placeholder="What would you like to tell me.."
              name="message"
              value={msg}
              onChange={onChangeMsg}
            ></textarea>
          </p>

          <button className="btn-custom mt-4" type="submit">
            Send Message
          </button>

          <div>
            <span className="fa fa-phone"></span>+2348060208486
            <span className="fa fa-envelope-o"></span>{" "}
            osaretin.frank10@gmail.com
          </div>
        </form>
      </div>
      <Footer />
    </>
  )
}
